import { push } from 'react-router-redux';

export const parseLeftMenuPath = menu => `/${menu.toLowerCase().split(' ').join('-')}`;

export const pushToURL = (e, dispatch, url) => {
  e.preventDefault();
  dispatch(push(url));
};

export const getQueryUrlFromObject = (obj) => {
    return Object.entries(obj ?? {}).filter(([, value]) => value).map(([key, value]) => `${key}=${value}`).join('&');
};
